"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSetEditorTheme = void 0;
const tslib_1 = require("tslib");
const useIsDarkMode_1 = tslib_1.__importDefault(require("./useIsDarkMode"));
/**
 * A React hook to set the theme of the Monaco editor based on the current theme mode.
 *
 * This function defines a custom theme called "argus-dark" and applies it if the theme mode
 * is dark. Otherwise, it sets the theme to "vs", which is the default light theme
 * of the Monaco editor. This hook uses the `useIsDarkMode` hook to determine if the dark mode
 * is enabled.
 *
 * @param {Object} params - The parameters object.
 * @param {function} params.defineTheme - The function to define a custom theme in the Monaco editor.
 * @param {function} params.setTheme - The function to set the active theme in the Monaco editor.
 * @returns {void} This function does not return a value.
 *
 * @example
 * // Typical use-case within a component that utilizes the Monaco editor
 * useSetEditorTheme({
 *   defineTheme: monaco.editor.defineTheme,
 *   setTheme: monaco.editor.setTheme
 * });
 */
const useSetEditorTheme = ({ defineTheme, setTheme }) => {
    const isDarkMode = (0, useIsDarkMode_1.default)();
    if (!defineTheme || !setTheme)
        return null;
    defineTheme("argus-dark", {
        base: "vs-dark",
        inherit: true,
        colors: {
            "editor.background": "#232323",
        },
        rules: [],
    });
    return setTheme(isDarkMode ? "argus-dark" : "vs");
};
exports.useSetEditorTheme = useSetEditorTheme;
